import React, { Component } from 'react';

import classNames from 'classnames';
import { Dropdown } from 'components/dropdown';
import TooltipPortal from 'components/tooltip/TooltipPortal';
import PropTypes from 'prop-types';

import { I18n } from '../../translate';

import './CanvasMenuDropDown.scss';

export default class CanvasMenuDropDown extends Component {
  static propTypes = {
    label: PropTypes.string,
    toolTip: PropTypes.string,
    active: PropTypes.bool,
    icon: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    preventCloseOnDropdownListClick: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    label: '',
    active: false,
    toolTip: '',
    icon: ''
  };

  get dropdownToggle() {
    const { label, toolTip, icon, className, active } = this.props;
    const buttonClassName = classNames(
      'canvas-menu__button',
      { 'canvas-menu__button--active': active },
      className
    );

    return (
      <div id={`canvas-menu-button__${icon}`} className={buttonClassName}>
        {toolTip && (
          <TooltipPortal parentId={`canvas-menu-button__${icon}`}>
            <I18n label={toolTip} />
          </TooltipPortal>
        )}
        {icon && <i className={`icon icon-${icon}`} />}
        {label && <I18n label={label} />}
      </div>
    );
  }

  render() {
    const { children, preventCloseOnDropdownListClick, onClick } = this.props;

    return (
      <Dropdown
        onClick={onClick}
        preventCloseOnDropdownListClick={preventCloseOnDropdownListClick}
        dropdownToggle={this.dropdownToggle}
        className="canvas-menu__drop-down"
      >
        {children}
      </Dropdown>
    );
  }
}
